import { getAccessToken, logOut } from "./token";

const requestHiddenFieldsAPI = async (url, options = {}) => {
  let token = await getAccessToken();
  const response = await fetch(`${process.env.REACT_APP_BASE_URL}${url}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    if (response.statusText === "Unauthorized") {
      logOut();
    }
    const data = await response.json();
    throw new Error(data?.message || "Request failed");
  }

  return response.json();
};

export const fetchHiddenFieldStaffUsersAPI = async (locationId) => {
  return requestHiddenFieldsAPI(`/api/webhook/staff/users?locationId=${encodeURIComponent(locationId)}`, {
    method: "GET",
  });
};

export const syncHiddenFieldStaffUsersAPI = async (locationId) => {
  return requestHiddenFieldsAPI("/api/webhook/sync-ghl-staff-users", {
    method: "POST",
    body: JSON.stringify({ locationId }),
  });
};

export const fetchHiddenFieldTemplatesAPI = async (locationId) => {
  return requestHiddenFieldsAPI(`/api/webhook/ghl-staff-templates?locationId=${encodeURIComponent(locationId)}`, {
    method: "GET",
  });
};

export const createHiddenFieldTemplateAPI = async (postData) => {
  return requestHiddenFieldsAPI("/api/webhook/ghl-staff-templates", {
    method: "POST",
    body: JSON.stringify(postData),
  });
};

export const deleteHiddenFieldTemplateAPI = async (templateId) => {
  return requestHiddenFieldsAPI(`/api/webhook/ghl-staff-templates/${encodeURIComponent(templateId)}`, {
    method: "DELETE",
  });
};

export const updateHiddenFieldTemplateStaffAPI = async (postData) => {
  return requestHiddenFieldsAPI("/api/webhook/ghl-staff-template-staff", {
    method: "PUT",
    body: JSON.stringify(postData),
  });
};

export const fetchHiddenFieldGroupsAPI = async (locationId, templateId) => {
  return requestHiddenFieldsAPI(`/api/webhook/get-ghl-groups-fields?locationId=${encodeURIComponent(locationId)}&templateId=${encodeURIComponent(templateId)}`, {
    method: "GET",
  });
};

export const updateHiddenFieldGroupsAPI = async (postData) => {
  return requestHiddenFieldsAPI("/api/webhook/ghl-groups-fields", {
    method: "PUT",
    body: JSON.stringify(postData),
  });
};
